import { format, isValid as isDateTimeValid, parse, subMinutes , addMinutes} from "date-fns";
import constant from "../../appConstants";
import { merge } from "lodash";
import { postData } from "../../api/componentAPIs";
import { utcToZonedTime, toDate } from "date-fns-tz";

// https://en.wikipedia.org/wiki/List_of_tz_database_time_zones 
// Timezones based on US daylight savings
const TIMEZONES ={
    CST : "America/Chicago",
    EST : "America/New_York"
}

// TODO : date fns library needs to be updated and we need to handle breaking changes
const formatDate = (params) => {
    if (params && params.value) {
        return format(getUTCDate(params.value), constant.DATETYPES.DATE.format);
    }
    return "";
}

const formatDateYear=(params) => {
    if (params && params.value) {
        return format(getUTCDate(params.value), constant.DATETYPES.DATEYEAR.format);
    }
    return "";
}

const formatMonthDateYear=(params) => {
    if (params && params.value) {
        return format(getUTCDate(params.value), constant.DATETYPES.MONTHDATEYEAR.format);
    }
    return "";
}

const formatMonthDateYearWithoutUTC=(params) => {
  if (params && params.value) {
      return format(params.value, constant.DATETYPES.MONTHDATEYEAR.format);
  }
  return "";
}

const formatTime = (params) => {
    if (params && params.value) {
        return format(getUTCDate(params.value), constant.DATETYPES.TIME.format);
    }
    return "";

}


const formatDateTime = (params) => {
    if (params && params.value) {
        return format(getUTCDate(params.value), constant.DATETYPES.DATETIME.format);
    }
    return "";
}

const formatDateTimeWithoutUTCConversion = (params) => {
    if (params && params.value) {
      return format(new Date(params.value), constant.DATETYPES.DATETIME.format);
    }
    return "";
  };

const formatESTDateTime = (params) => {
    if (params && params.value) {
        const estDateTime = utcToZonedTime(params.value, TIMEZONES.EST ); // America/New_York gets EST time based on daylight savings https://en.wikipedia.org/wiki/List_of_tz_database_time_zones
        return format(estDateTime, constant.DATETYPES.DATETIME.format);
    }
    return "";
}

const formatCSTTimeStringToEST = params => {
    if (params && params.value) {
        const timeString = params.value.padStart(4,0);
        const dateTimeStringFormat =  "yyyy-MM-dd'T'HH:mm:00.000";
        const formattedDateTimeString  = format(parse(timeString, "HHmm", new Date()), dateTimeStringFormat);
        const cstDateTime = toDate(formattedDateTimeString,  { timeZone: TIMEZONES.CST });
        const estDateTime = utcToZonedTime(cstDateTime, TIMEZONES.EST );
        return format(estDateTime, constant.DATETYPES.TIME.format);
    }
    return "";
}


const minutesToTime = params => {
    if (params && params.value !== null && params.value !== undefined) {
        const minutes = parseInt(params.value);
        const hour = Math.floor(minutes / 60);
        const min = minutes % 60;
        // const newDate = new Date();
        // newDate.setHours(hour);
        // newDate.setMinutes(min);
        // return format(newDate,"hh:mm");
        return `${hour.toString().padStart(2,"0")}:${min.toString().padStart(2,"0")}`
    }
    return null;
}

// automatic convertion from datetime to minutes
function timeToMinutes(params) {
    if (params) {
        let newValue = null
        if (params.newValue) {
            const updatedDate = getUTCDate(params.newValue);
            newValue = updatedDate.getHours() * 60 + updatedDate.getMinutes();
        }
        params.data[params.colDef.field] = newValue;
    }
    return true;
}

// Converts datetime string to minutes , used for bulk updates
function convertTimeToMinute(time) {
    if (time) {
        const updatedDate = getUTCDate(time);
        return updatedDate.getHours() * 60 + updatedDate.getMinutes();
    }
    return null;
}


const roundingNumbers = params => {
    if (params && Number(params.value) == params.value) {
        return params.value.toFixed(2);
    }
    return "";
}

function setTimeFromDateTime(params) {
    if (params) {
        let newValue = null;
        if (params.newValue) {
            newValue = format(getUTCDate(params.newValue), constant.DATETYPES.TIME.format);
        }
        params.data[params.colDef.field] = newValue;
    }
    return true;
}

function convertDateTimeToTimeString(dateTimeString) {
    if (dateTimeString) {
        const dateTime = getUTCDate(dateTimeString);
        return format(dateTime, constant.DATETYPES.TIME.format);
    }
    return null;
}

const saveGridColumnState = ({ gridName, columns, userColumnPref }) => {
    const columnDefs = columns.map((column) => ({
      headerName: column.colDef.defaultHeaderName ?? column.colDef.headerName, // use defaultHeaderName while saving if it is present to avoid resetting column properties in userConfig
      hide: !column.visible,
      pinned: column.isPinned() ? "left" : null,
    }));
    if (!userColumnPref) {
        userColumnPref = {}
    }
    userColumnPref[`${gridName}_Config`] = { columns: columnDefs };
    postData("SetUserPreferences", {
        columnOrderPref: JSON.stringify(userColumnPref)
    }).then(response => {
        if(response && Math.trunc(response.status/100) === 2) {
            console.log("user column preferences saved");
        }
    },
        error => {
            console.log("Error while saving column preferences ", error);
        }
    )
    return userColumnPref;
}

function isTimeValid(timeString) {
    const dateTime = parse(timeString, constant.DATETYPES.TIME.format, new Date());
    return isDateTimeValid(dateTime);
}

function mergeUserConfig({ defaultConfig, userConfig }) {
    if (userConfig && typeof userConfig === "object" && Object.keys(userConfig).length > 0) {
        if (userConfig[`${defaultConfig.title}_Config`]) {
            const mergedColumns = mergeColumnConfig(defaultConfig.columns, userConfig[`${defaultConfig.title}_Config`].columns);
            const mergedToggles = mergeGridMapConfig(defaultConfig.toggles, userConfig[`${defaultConfig.title}_Config`].toggles);
            const mergedConfig = {
                ...defaultConfig,
                ...userConfig,
                columns: mergedColumns,
                toggles: mergedToggles,
            }
            return mergedConfig;
        }
    }
    return defaultConfig;
}

function mergeGridMapConfig(defaultToggles, userToggles) {
    if (!userToggles) {
        userToggles = {}
    }
    return Object.keys(userToggles).length === 0 ? 
        defaultToggles : 
        {...defaultToggles, ...userToggles};
}

function mergeColumnConfig(defaultColumns, userColumns) {
    if(userColumns && Array.isArray(userColumns) && userColumns.length > 0 && defaultColumns && Array.isArray(defaultColumns) && defaultColumns.length > 0){
        let mergedColumns = [];

        // Merge columns from userPreference and gridConifg , skip column removed from gridConfig
        userColumns.forEach((userColumn) => {
            const defaultCol = defaultColumns.find(defualtCol => defualtCol.headerName === userColumn.headerName);
            if(defaultCol){ // if column was not found in default config then it was deleted in gridconfig, remove it for user too
                mergedColumns.push(merge(defaultCol, userColumn))
            }
        });

        // Add new columns in gridConfig in their defined positions
        defaultColumns.forEach((defaultCol,index) => {
            if(mergedColumns.findIndex(mergedColumn => mergedColumn.headerName === defaultCol.headerName) < 0){
                mergedColumns.splice(index,0, defaultCol)
            }
        });
        return mergedColumns;
    }
    return defaultColumns || [];
}

const getUTCDate = (dateString = Date.now()) => {
    const date = new Date(dateString);

    return new Date(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        date.getUTCHours(),
        date.getUTCMinutes(),
        date.getUTCSeconds(),
    );
};

const getMinutesfromTimeString = (str) => {
    if (str) {
        const time = str.split(":");
        return time[0] * 60 + Number(time[1]);
    }
    return 0;
};

const getDateWithUtcHoursAndMinFromTimeString = (timeString) => {
    if (timeString) {
      const date = new Date();
      const [hours, mins] = timeString.split(":").map(Number);
      date.setUTCHours(hours);
      date.setUTCMinutes(mins);
      return date;
    }
    return null;
}

const formatDeliveryWindow = (params) => {
    if (params && params.data && params.value?.length > 0) {
      if (Array.isArray(params.value)) {
        return params.value
          ?.filter((deliverySlot) => {
            const newOption = {
              data: params.data,
              value: deliverySlot,
            };
            return checkDeliveryWindowConstraints(newOption);
          })
          .join(" , ");
      } else {
        return checkDeliveryWindowConstraints(params);
      }
    }
  return params.value?.join?.(",") ?? "";
}

const checkDeliveryWindowConstraints = (params) => {
  if (!params.value) {
    return "";
  }
  if (
    hasDefaultDeliveryWindow(params.value) &&
    !isAppointmentShipmentAndPriorityStartWithSGS(params.data)
  ) {
    return "";
  }
  return params.value;
};

const hasDefaultDeliveryWindow = (deliveryWindowValue) => {
  // delivery window ranges from 08:00 - 17:00
  const deliveryWindow = deliveryWindowValue.split("-");
  const startTime = getMinutesfromTimeString(deliveryWindow[0].trim());
  const endTime = getMinutesfromTimeString(deliveryWindow[1].trim());
  return startTime === 480 && endTime === 1020;
};

const isAppointmentShipmentAndPriorityStartWithSGS = (data) => {
  //not a priority shipment of type APT or SGS
  const { priority, apt } = data;
  const isAPT = apt ? true : false;
  return (priority && priority.startsWith("SGS")) || isAPT;
};

const getFormattedDeliveryWindowList = (params) => {
  return formatDeliveryWindow(params).split(" , ")
}

const getDeliveryWindowByEarlyAndLateCTA = (data) => {
  if (data?.earlyCta && data?.lateCta) {
    return `${formatDateTime({value : data.earlyCta})} - ${formatDateTime({value :data.lateCta})}`
  }
  return ""
}

const formatZeroValue = (params) => {
    if (params && params.value) {
        return params.value;
    }
    return "";
}

function suppressEnter(params) {
    const KEY_ENTER = 13;
    const { keyCode } = params.event || {};
    return keyCode === KEY_ENTER;
  }

function svcValueGetter(params) {
  let priority = params.data.isApt ? [constant.SpecialNeedsStrings.APT] : [];
  if (params.data.priority && !Array.isArray(params.data.priority)) {
    priority = [...priority, params.data.priority];
  } else if (params.data.priority){
    priority = [...priority, ...params.data.priority]
  }
  return priority.join(", ");
}

function hazmatValueGetter(params) {
  if (params.data.isHazmat) {
    return [constant.SpecialNeedsStrings.HZ];
  } else {
    return [];
  }
}

const isValidTimeValue = (value) => {
    return value === "Invalid_Time";
}

const subtractMinutesFromDate = (date, time) => {
    return subMinutes(new Date(date), time);
};

export {
    formatDate,
    formatTime,
    formatDateTime,
    formatESTDateTime,
    formatCSTTimeStringToEST,
    minutesToTime,
    roundingNumbers,
    mergeUserConfig,
    saveGridColumnState,
    setTimeFromDateTime,
    timeToMinutes,
    convertTimeToMinute,
    convertDateTimeToTimeString,
    isTimeValid,
    getUTCDate,
    getMinutesfromTimeString,
    formatDeliveryWindow,
    getFormattedDeliveryWindowList,
    getDeliveryWindowByEarlyAndLateCTA,
    suppressEnter,
    formatZeroValue,
    formatDateYear,
    formatDateTimeWithoutUTCConversion,
    formatMonthDateYear,
    formatMonthDateYearWithoutUTC,
    getDateWithUtcHoursAndMinFromTimeString,
    svcValueGetter,
    hazmatValueGetter,
    checkDeliveryWindowConstraints,
    isValidTimeValue,
    hasDefaultDeliveryWindow,
    subtractMinutesFromDate
};
